import { numberAlignRight, textBreakWord } from 'src/features/base/components/Table/Table.props'

export default [
  {
    Header: 'FC',
    id: 'fulfillmentCenter.name',
    accessor: 'fulfillmentCenter.name',
    width: 140,
    getProps: textBreakWord,
  },
  {
    Header: 'Categoria',
    id: 'category',
    accessor: 'category',
    width: 100,
  },
  {
    Header: 'ID Modelo',
    id: 'modelId',
    accessor: 'modelId',
    width: 100,
    getProps: numberAlignRight,
  },
  {
    Header: 'Código',
    id: 'code',
    accessor: 'code',
    width: 70,
    getProps: numberAlignRight,
  },
  {
    Header: 'Nome',
    id: 'description',
    accessor: 'description',
    width: 320,
    getProps: textBreakWord,
  },
  {
    Header: 'Total',
    id: 'total',
    accessor: 'total',
    width: 70,
    getProps: numberAlignRight,
  },
  {
    Header: 'Reservado Total',
    id: 'reserved',
    accessor: 'reserved',
    width: 100,
    getProps: numberAlignRight,
  },
  {
    Header: 'Disponível',
    id: 'available',
    accessor: 'available',
    width: 100,
    getProps: numberAlignRight,
  },
  {
    Header: '',
    id: 'dumb',
    accessor: 'dumb',
    width: 1,
  },
]
